import { createContext, useContext } from 'react';

/** Raw model reasoning is an administrator diagnostic; stage conclusions remain public. */
export const DiagnosticsVisibilityContext = createContext(false);
export const useCanViewDiagnostics = () => useContext(DiagnosticsVisibilityContext);
